<template lang="html">
    <div>
        <table class="table table-striped table-hover" style="margin-bottom: 0px;">
            <thead>
                <tr>
                    <th v-for="(header, index) in headers" :style="header.style" v-on:click="sort(index)">
                        <div class="title">
                            {{ header.title }}
                            <div class="pull-right">
                                <span class="fa" v-if="header.sortBy != ''" :class="{'fa-sort-amount-asc': header.sortBy == 'asc', 'fa-sort-amount-desc': header.sortBy == 'desc'}"></span>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in tempRows" :class="{lastRow: isLastRow(rowIndex)}">
                    <td v-for="(cell, columnName, index) in row" :style="cell < 1 ? 'color: #999': ''">
                        <div v-if="headers[index].isHtml" v-html="cellFormat(headers[index],cell)"></div>
                        <div v-else="headers[index].isHtml">
                            {{ cellFormat(headers[index],cell) }}
                        </div>
                        <div v-if="hasColumnAction(columnName)">
                            <div class="btn-group">
                                <button v-on:click="callColumnAction(columnName, row, actionIndex)" v-for="(action, actionIndex) in getColumnActions(columnName)" class="btn btn-sm primary">{{action.title}}</button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import takeRight from 'lodash.takeright';
    import concat from 'lodash.concat';
    import forEach from 'lodash.foreach';
    import sortBy from 'lodash.sortby';
    import map from 'lodash.map';
    import moment from 'moment';
    import findLastIndex from 'lodash.findlastIndex';
    import dropRight from 'lodash.dropright';
    import pick from 'lodash.pick';
    import 'sticky-table-headers';

    export default {
        props: {
            headers: {
                type: Array,
                required: true
            },
            rows: {
                type: Array,
                required: true
            },
            hasTotalRow: {
                type: Boolean,
                default: false,
                required: false
            },
            totalRowCount: {
                type: Number,
                default: 1,
                required: false
            },
            initialSortColumn: {
                type: Number,
                default: 0,
                required: false
            },
            initialSortBy: {
                type: String,
                default: 'asc',
                required: false
            },
            columnActions: {
                type: Object,
                required: false,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                tempRows: [],
                tempHeaders: [],
                lastSortedIndex: this.initialSortColumn,
                lastSortOrderBy: this.initialSortBy
            }
        },
        watch: {
            rows: function () {
                this.sort(this.lastSortedIndex, this.lastSortOrderBy);
            },
            headers: function () {
                this.tempHeaders = this.headers;
            }
        },
        methods: {
            sort: function (index, orderBy) {
                this.lastSortedIndex = index;
                let that = this;
                let lastRows = null;
                let headerKeys = map(this.headers, function(header) {
                    return header.columnName;
                });
                let sortedData = map(this.rows, function (row) {
                    return pick(row, headerKeys);
                });
                if (this.hasTotalRow === true) {
                    lastRows = takeRight(sortedData, this.totalRowCount);
                    sortedData = dropRight(sortedData, this.totalRowCount);
                }
                sortedData = map(sortBy(sortedData, function (a) {
                    return that.format(that.headers[index], a[that.headers[index].columnName]);
                }));
                if (orderBy !== undefined) {
                    this.lastSortOrderBy = orderBy;
                    if (orderBy === 'desc') {
                        this.headers[index].sortBy = 'desc';
                    } else {
                        this.headers[index].sortBy = 'asc';
                    }
                } else {
                    if (this.headers[index].sortBy === 'desc') {
                        this.headers[index].sortBy = 'asc';
                    } else {
                        this.headers[index].sortBy = 'desc';
                    }
                    this.lastSortOrderBy = this.headers[index].sortBy;
                }
                if (this.lastSortOrderBy === 'desc') {
                    sortedData = sortedData.reverse();
                }
                if (this.hasTotalRow === true) {
                    sortedData = concat(sortedData, lastRows);
                }
                this.tempRows = sortedData;

                forEach(this.headers, function (header, headerIndex) {
                    if (index !== headerIndex) {
                        header.sortBy = '';
                    }
                });
                $('table').stickyTableHeaders({marginTop: 55});
            },
            format: function (header, value) {
                if (header.hasOwnProperty('regex')) {
                    let result = value.match(header.regex);
                    if (result !== undefined) {
                        value = result[0];
                    }
                }
                if (header.dataFormat === 'string') {
                    return value;
                } else if (header.dataFormat === 'integer') {
                    return parseInt(value);
                } else if (header.dataFormat === 'date') {
                    return moment(value, header.dateFormat);
                } else if (header.dataFormat === 'decimal') {
                    return parseFloat(value);
                }
            },
            isLastRow: function (index) {
                return this.hasTotalRow === true && index > (findLastIndex(this.tempRows) - this.totalRowCount);
            },
            hasColumnAction: function (columnName) {
                return this.columnActions.hasOwnProperty(columnName);
            },
            getColumnActions: function (columnName) {
                return this.columnActions[columnName];
            },
            callColumnAction: function (columnName, row, actionIndex) {
                this.$parent[this.columnActions[columnName][actionIndex].actionMethod](row);
            },
            cellFormat(header, value) {
                if(header.hasOwnProperty('valueFormat') !== false && header.valueFormat === 'integer') {
                    let val = (value/1).toFixed(0).replace('.', ',');
                    value = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                }
                return value;
            }
        }
    }
</script>

<style lang="css" scoped>
    th {
        cursor: pointer;
        background: #eee;
        border-bottom: 2px solid #eceeef;
        vertical-align: bottom;
    }

    .title {
        position: relative;
        padding: 4px 18px 4px 4px;
        display: block;
        font-size: 11px;
    }

    .title:after, .title:before {
        box-sizing: inherit;
    }

    tr.lastRow td:first-child {
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// table.v2.vue?50f138be